export default __webpack_public_path__ + "media/images/onglet-droitsmall-ca5a3d2ca7ccce4d3470963f3696254b.png";